import { render, staticRenderFns } from "./tabSpecialApproval.vue?vue&type=template&id=2f5dcf8c&"
import script from "./tabSpecialApproval.vue?vue&type=script&lang=js&"
export * from "./tabSpecialApproval.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../../../Users/qiancheng/Documents/Workspace/cargoware/cargoware-h5-haichuang/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/qiancheng/Documents/Workspace/cargoware/cargoware-h5-haichuang/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('2f5dcf8c')) {
      api.createRecord('2f5dcf8c', component.options)
    } else {
      api.reload('2f5dcf8c', component.options)
    }
    module.hot.accept("./tabSpecialApproval.vue?vue&type=template&id=2f5dcf8c&", function () {
      api.rerender('2f5dcf8c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/cargo/v0/Sales/components/CreditBusinessManage/tabSpecialApproval.vue"
export default component.exports